module.exports = __webpack_public_path__ + "img/live-chat-mp4.36cb56aa.png";